import { KalturaHouseholdDevice } from '@kaltura-ott/ott-client-types';
import { action } from 'mobx';
import { container, singleton } from 'tsyringe';

import type { DeviceStore } from '../stores/user/device-store';
import type { RemoveHouseholdDeviceResponse } from '../types/stores/device-store-type';

@singleton()
export class DeviceStoreFacade {
  originalStore: DeviceStore;

  constructor() {
    this.originalStore = container.resolve<DeviceStore>('deviceStore');
  }

  public get householdList() {
    return this.originalStore.householdList;
  }

  public get totalStreamingDevices() {
    return this.originalStore.totalStreamingDevices;
  }

  public get householdDevice() {
    return this.originalStore.householdDevice;
  }

  public get deviceLimitExceeded() {
    return this.originalStore.deviceLimitExceeded;
  }

  public get householdTotalCount() {
    return this.originalStore.householdTotalCount;
  }

  /**
   *  resetStore to the default state
   * @returns void
   */
  @action.bound
  public resetStore() {
    return this.originalStore.resetStore();
  }

  /**
   *  Remove device from household by UDID and trying to add the current device to household
   * @param udid: string
   * @param addCurrentDevice: boolean
   *
   * @returns Promise RemoveHouseholdDeviceResponse
   */
  @action.bound
  public async removeHouseholdDevice(udid: string, addCurrentDevice?: boolean): Promise<RemoveHouseholdDeviceResponse> {
    return this.originalStore.removeHouseholdDevice(udid, addCurrentDevice);
  }

  /**
   * Get new list of devices of the current household and save it to `householdList` property
   *  @returns Promise<void>
   */
  @action.bound
  public async getDeviceList(): Promise<void> {
    return this.originalStore.getDeviceList();
  }

  /**
   * Get new list of devices of the current household and save it to `householdList` property
   *  @returns Promise void | KalturaHouseholdDevice
   */
  @action.bound
  async addDevice(): Promise<void | KalturaHouseholdDevice> {
    return this.originalStore.addDevice();
  }
}
